import type { ReactNode } from 'react'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState, IllustrationEmpty, Spinner } from '@rentflowdev/ui'
import { opens, useAccess } from '@/lib/access'
import { requirementFor } from './nav-items'

/** Shown instead of a section the role does not reach. */
export function NoAccess() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	return (
		<div className="flex h-full items-center justify-center p-6">
			<EmptyState
				illustration={<IllustrationEmpty />}
				title={t('common.noAccess.title')}
				description={t('common.noAccess.description')}
				actionSlot={
					<Button onClick={() => void navigate({ to: '/' })}>
						{t('common.noAccess.home')}
					</Button>
				}
			/>
		</div>
	)
}

/**
 * Closes the sections of the menu the role does not reach: a direct link
 * shows NoAccess, not a page of 403 errors. The menu hides the same sections
 * (requirementFor reads the same table); the gateway still refuses.
 */
export function AccessGate({ children }: { children: ReactNode }) {
	const { pathname } = useLocation()
	const access = useAccess()
	const requirement = requirementFor(pathname)

	if (!requirement) return children
	if (access.status === 'loading') {
		return (
			<div className="flex h-full items-center justify-center">
				<Spinner />
			</div>
		)
	}
	return opens(access, requirement) ? children : <NoAccess />
}
